import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, NavController, NavParams, Platform, ToastController } from '@ionic/angular';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ClubInfo } from 'src/data/club-course';
import {
  ClubData,
  ClubMembershipExtended,
  ClubMembershipOption,
  ClubMembershipType,
  Country,
  EInvoicingEntityForm,
  PlayerData,
  PlayerInfo,
  initEInvoicingEntityForm,
  State,
  initEInvoicingSetupForm,
  EInvoicingSetupForm,
} from 'src/data/mygolf.data';
import { getDistanceInKM } from 'src/globals';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { ClubService } from 'src/providers/club-service/club-service';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { CountryListPage } from '../../modal-screens/country-list/country-list.page';
import { PlayerService } from 'src/providers/player-service/player-service';
import { key } from 'localforage';

export interface StateCities {
  state?: string;
  cities?: string[];
}
@Component({
  selector: 'app-e-invoice-info',
  templateUrl: './e-invoice-info.page.html',
  styleUrls: ['./e-invoice-info.page.scss'],
})
export class EInvoiceInfoPage implements OnInit {
  public refresher: any;
  public infinite: any;
  public searchQuery: string = '';

  public recentClubs: Array<ClubInfo>;
  public nearByClubs: Array<ClubInfo>;

  clubInfo: ClubData; //ClubInfo;
  player$: Observable<PlayerInfo>;

  clubMembershipTypes: Array<ClubMembershipType>;

  selMembershipType: ClubMembershipType = null;
  clubMembershipOption: ClubMembershipOption;
  enableStatementEmail: boolean = false;
  correspondenceEmail: string;
  setHomeClub: boolean = false;
  joinedOn: string;
  validUntil: string;
  editMode: boolean = false;
  @Input() clubMembership: ClubMembershipExtended;
  membershipNo: string;

  modalMode: boolean = true;
  fromClub: boolean = false;
  selectedMembershipType: string = 'FULL';
  maxDate: string;

  nricNo: string;
  passportNo: string;
  legalName: string;
  incomeTaxNo: string;
  phoneNo: string;
  eInvoiceType: string = 'individual';
  tourismNo: string = '';
  sstNo: string = '';
  businessName: string = '';
  businessROCNo: string = '';
  businessAddress: string = '';
  shippingAddress: string = '';
  address1: string = '';
  address2: string = '';
  city: string = '';
  state: string = '';
  postalCode: string = '';
  phoneNumbers: string = '';
  country: string = '';
  taxIdentificationNumber: string = '';

  @ViewChild('imgUpload')
  imgUpload: ElementRef;

  company: EInvoicingEntityForm & EInvoicingSetupForm;
  individual: EInvoicingEntityForm & EInvoicingSetupForm;

  @Input() playerData: PlayerData;
  @Input() type: string = 'updateSetup';
  @Input() einvoiceEntity: EInvoicingSetupForm;
  @Input() mode: string = 'add';
  citiesList: Array<StateCities>;
  constructor(
    private router: Router,
    private navParams: NavParams,
    private modalCtl: ModalController,
    private flightService: ClubFlightService,
    private geo: GeolocationService,
    private loadingCtl: LoadingController,
    private clubService: ClubService,
    private platform: Platform,
    private toastCtl: ToastController,
    private nav: NavController,
    private alertCtl: AlertController,
    private mg2uUtils: mygolfUtils,
    private playerService: PlayerService
  ) {}

  ngOnInit() {
    this.recentClubs = new Array<ClubInfo>();
    this.nearByClubs = new Array<ClubInfo>();

    if (this.type === 'updateSetup') {
      this.individual = initEInvoicingSetupForm();
      this.company = initEInvoicingSetupForm();

      this.individual.country = 'MYS';
      this.company.country = 'MYS';
      this.country = 'MYS';
    } else {
      this.individual = initEInvoicingEntityForm();
      this.company = initEInvoicingEntityForm();
    }

    if (this.router.getCurrentNavigation()) {
      this.player$ = this.router.getCurrentNavigation().extras.state.player;
      this.clubInfo = this.router.getCurrentNavigation().extras.state.clubInfo;
      this.editMode = this.router.getCurrentNavigation().extras.state.editMode;
      this.clubMembership = this.router.getCurrentNavigation().extras.state.clubMembership;
      this.fromClub = this.router.getCurrentNavigation().extras.state.fromClub;
      this.playerData = this.router.getCurrentNavigation().extras.state.playerData;
    } else {
      this.player$ = this.navParams.get('player');
      this.clubInfo = this.navParams.get('clubInfo');
      this.editMode = this.navParams.get('editMode');
      this.clubMembership = this.navParams.get('clubMembership');
      this.fromClub = this.navParams.get('fromClub');
      this.playerData = this.navParams.get('playerData');
    }

    console.debug('this.player$', this.player$, this.navParams.get('player'));

    this.validUntil = moment().format('YYYY-MM-DD');
    this.joinedOn = moment().format('YYYY-MM-DD');
    this.maxDate = moment().add(30, 'y').format('YYYY-MM-DD');
    console.log('EInvoiceInfoPage initialized');
    console.log('playerData:', this.playerData);
    console.log('type:', this.type);
    console.log('mode:', this.mode);
    console.debug('populate info - einvoice', this.mode, this.type, this.einvoiceEntity);
    if (this.type === 'updateSetup') {
      if (this.mode === 'edit') {
        this.populateEInvoiceInfo();
      }
    } else {
      this.populateEInvoiceInfo();
    }

    this.getStatesList();
    // this._refreshValues();
    if (this.editMode) {
      // this.selMembershipType = this.clubMembership.membershipType;
    }
    this.getCountry();
    this.getStatesCitiesList();
  }

  getCountry() {
    this.playerService.getCountryList().subscribe((data: Array<Country>) => {
      this.countryList = data;
    }),
      error => {},
      () => {};
  }

  onSearchInput(searchbar) {
    this._refreshValues();
  }

  /**
   * Gets the distance between a current location and club in KMs
   * @param club The club information
   * @returns {number} Returns the distance in KM if GPS locations of current and club are available
   * else returns 0;
   */
  clubDistance(club: ClubInfo): string {
    let lat1 = this.geo.getLatitude();
    let lon1 = this.geo.getLongitude();
    if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
      return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + ' KM';
    return '';
  }

  /**
   * Executed when refresh button on toolbar is clicked
   */
  onRefreshClick(refresher) {
    this.refresher = refresher;
    this._refreshValues();
  }

  clubSelected(event, item: ClubInfo) {
    // this.events.publish("clubSelected", item);
    this.clubMembershipNumberPrompt();
  }

  private async _refreshValues() {}

  async clubMembershipNumberPrompt() {
    let prompt = await this.alertCtl.create({
      header: 'Club Membership',
      message: 'Enter your club Membership Number',
      inputs: [
        {
          name: 'membershipNumber',
          placeholder: 'Membership Number',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Save',
          handler: data => {
            this.nav.pop();
          },
        },
      ],
    });
    prompt.present();
  }

  getPlayerDetails(attribute?: string) {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    switch (attribute) {
      case 'name':
        return _player.playerName;
    }
  }

  getClubDetails(attribute?: string) {
    let _clubInfo: ClubData;
    let _clubName;
    if (!this.editMode) _clubInfo = this.clubInfo;
    else if (this.editMode) _clubName = this.clubMembership.club.name;

    switch (attribute) {
      case 'name':
        if (this.editMode) return _clubName;
        else return _clubInfo.clubName || _clubInfo.name;
    }
  }

  onClose() {
    this.modalCtl.dismiss();
  }

  onChangeMembershipType() {
    console.debug('on change membership type ', this.selMembershipType, this.selectedMembershipType);
    // if(!this.selMembershipType) return;
    // let _selectedType;
    this.clubMembershipTypes
      .filter(type => {
        return type.typeId === this.selectedMembershipType;
      })
      .map(type => {
        this.selMembershipType = type;
        if (!this.selMembershipType.termMembership) {
          this.validUntil = '2999-12-31';
        } else if (this.selMembershipType.termMembership) {
          this.validUntil = moment().add(1, 'y').format('YYYY-MM-DD');
        }
      });
  }

  async onClickMembershipType() {
    console.debug('in click membership type : ', this.clubMembershipTypes);
    if (!this.clubMembershipTypes) return;
    if (this.editMode && this.clubMembership.active && this.clubMembership?.membershipType) return;

    let _dataList = [];
    if (this.clubMembershipTypes?.length > 0) {
      this.clubMembershipTypes.forEach(type => {
        _dataList.push({
          id: type.typeId,
          name: type.typeName,
        });
      });
    }

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data?.data) {
        this.selectedMembershipType = this.clubMembershipTypes.find((type: ClubMembershipType) => {
          return type.typeId === data.data.id;
        }).typeId;
        this.selMembershipType = this.clubMembershipTypes.find((type: ClubMembershipType) => {
          return type.typeId === data.data.id;
        });
        this.onChangeMembershipType();
      }
      // if(data)
    });
  }

  getSelectedTypeInfo(attribute: string) {
    if (this.selectedMembershipType) return '';
    let _typeInfo = this.clubMembershipTypes.find((type: ClubMembershipType) => {
      return type.typeId === this.selectedMembershipType;
    });
    switch (attribute) {
      case 'name':
        return _typeInfo.typeName;
      case 'id':
        return _typeInfo.typeId;
    }
  }

  selectedFiles: any;
  temporaryImageURL: string;
  previewImage: any;
  async takePhotoFromGallery(event, mode?: string) {
    // if (event) {
    //   const fileObject = event.target.files[0];
    // }

    this.selectedFiles = event.target.files[0];
    // const file = (event.target as HTMLInputElement).files;
    //

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      const images = [];
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        reader.onload = (event: any) => {
          // Push Base64 string
          images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
      this.temporaryImageURL = event.target.files[0].name;
      this.previewImage = images;

      // if (this.selectedFiles && mode === 'update')
      //   this._uploadImage(this.temporaryImageURL);
    }
  }

  deleteImage() {
    this.selectedFiles = null;
    this.temporaryImageURL = null;
    // if(this.playerDiscountProgram?.document){
    //    this.playerDiscountProgram.document = null;
    // }
  }

  getMemberImage() {
    if (this.clubMembership?.memberImage) return this.clubMembership.memberImage;
    // else if(this.previewImage) return this.previewImage
    else return this.temporaryImageURL;
  }

  getCountryInfo(countryId, type: string) {
    if (!this.countryList) return;
    if (this.eInvoiceType === 'individual' && !this.individual?.country) return 'Tap here to select';
    else if (this.eInvoiceType === 'company' && !this.company?.country) return 'Tap here to select';
    // if (!this.country && type === 'country') {
    //   return 'Tap here to select';
    // }
    let _country;
    this.countryList
      .filter(c => {
        if (type === 'country') return c.id === this.country || c.id === countryId;
      })
      .map(c => {
        _country = c;
      });
    return _country?.name;
  }
  countryList: Array<any>;
  async onSelectCountry(type: string) {
    if (1) {
      const fixedCountry = 'MYS';
      if (this.eInvoiceType === 'individual') {
        this.individual.country = fixedCountry;
      } else if (type === 'country') {
        this.company.country = fixedCountry;
      }
      this.country = fixedCountry;
      return;
    }
    let modal = await this.modalCtl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        headerName: this.eInvoiceType === 'individual' ? 'Select Residing In' : 'Select Origin Company Country',
        excludeAll: true,
      },
    });
    modal.onDidDismiss().then((country?: any) => {
      if (country?.data) {
        let _country: Country = country.data;
        if (this.eInvoiceType === 'individual') {
          this.individual.country = _country.id;
        } else if (type === 'country') {
          this.company.country = _country.id;
          this.country = _country.id;
        }
        console.debug('selected country : ', type, country, _country, this.country, this.individual, this.company);
      }
    });
    modal.present();
  }

  toggleInvoiceType(data: string) {
    if (!data) return;
    this.eInvoiceType = data;
    if (data === 'company') {
      this.individual.idType === 'BRN';
    }
    this.validatedInfo = null;
  }

  getFlagUrl() {}

  getDocumentType() {
    if (this.eInvoiceType === 'individual') {
      return this.individual?.idType;
    } else if (this.eInvoiceType === 'company') {
      return this.company?.idType;
    }
  }

  async onSelectDocumentType() {
    let _documentType = '';
    if (this.eInvoiceType === 'individual') {
      _documentType = this.individual?.idType;
    } else if (this.eInvoiceType === 'company') {
      _documentType = this.company?.idType;
    }

    let _dataList = [
      {
        id: 'NRIC',
        name: 'National Registration Identity Card',
        iconUrl: 'assets/icons/golf-website.png',
      },
      {
        id: 'PASSPORT',
        name: 'Passport Number',
        iconUrl: 'assets/icons/book.png',
      },
      {
        id: 'ARMY',
        name: 'Army Identification Card',
        iconUrl: 'assets/icons/golf-field.png',
      },
    ];
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'Identification Document Type',
        selectedValue: _documentType,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      let _idType = '';
      if (data?.data) {
        _idType = data?.data?.id;
        if (this.eInvoiceType === 'individual') {
          this.individual.idType = _idType;
        } else if (this.eInvoiceType === 'company') {
          this.company.idType = _idType;
        }
      }
      // if(data)
    });
  }

  onSaveEInvoiceInfo() {
    if (this.eInvoiceType === 'individual') {
      if (!this.individual.idType) {
        MessageDisplayUtil.showMessageToast('Please specify an Identification Type', this.platform, this.toastCtl, 3000, 'bottom');
        return false;
      }
      if (!this.individual.idValue || this.individual?.idValue?.length === 0) {
        MessageDisplayUtil.showMessageToast('Please specify an Identification Number', this.platform, this.toastCtl, 3000, 'bottom');
        return false;
      }
    } else if (this.eInvoiceType === 'company') {
      if (!this.company?.businessRegistrationNumber) {
        MessageDisplayUtil.showMessageToast('Please specify Company Registration Number', this.platform, this.toastCtl, 3000, 'bottom');
        return false;
      }
    }
    if (this.type === 'updateSetup') {
      this.goDismissEInvoiceInfo();
    } else {
      this.goSaveEInvoiceInfo();
    }
  }

  onValidateFields() {
    return new Promise((resolve, reject) => {});
  }

  goSaveEInvoiceInfo() {
    let _clubId;
    if (this.editMode) {
      _clubId = this.clubMembership.club.id;
    } else {
      _clubId = this.clubInfo?.clubId || this.clubInfo?.id;
    }
    let _player: PlayerData = this.playerData;

    if (this.selectedMembershipType === 'FULL') this.validUntil = '2999-12-31';
    // let _params;
    // _params = {
    //   membershipNo: this.membershipNo,
    //   membershipType: this.selectedMembershipType,
    //   joinedOn: this.joinedOn,
    //   validUntil: this.validUntil,
    //   statementEmail: this.enableStatementEmail,
    //   correspondenceEmail: this.correspondenceEmail,
    //   homeClub: this.setHomeClub,
    //   icNumber: this.nricNo,
    //   passport: this.passportNo,
    //   legalName: this.legalName,
    //   incomeTaxNumber: this.incomeTaxNo,
    //   phoneNumber: this.phoneNo,
    //   individual: this.eInvoiceType === 'individual'?true:false,
    //   companyName: this.businessName || '',
    //   businessRegistrationNumber: this.businessROCNo || '',
    //   sst: this.sstNo || '',
    //   tourismNumber: this.tourismNo || '',
    //   address1: this.address1 || '',
    //   address2: this.address2 || '',
    //   city: this.city || '',
    //   state: this.state || '',
    //   postalCode: this.postalCode || '',
    //   phoneNumbers: this.phoneNumbers?.split(',') || '',
    //   einvoicingOption: this.mg2uUtils.capitalizeFirstLetter(this.eInvoiceType),
    //   country: this.country || '',
    // }
    let _individualForm: EInvoicingEntityForm = initEInvoicingEntityForm();
    let _companyForm: EInvoicingEntityForm = initEInvoicingEntityForm();
    let _country = this.country || 'MYS';
    let _einvoicingOption = this.mg2uUtils.capitalizeFirstLetter(this.eInvoiceType);
    let _params = {
      eInvoicingOption: _einvoicingOption,
      // individual: _individualForm,
      // company: _companyForm,
      country: _country,
    };
    if (this.eInvoiceType === 'individual' || this.individual?.idType?.length > 0) {
      for (let key in this.individual) {
        if (key?.toLowerCase().includes('state')) console.debug('form individual : ', key, this.individual[key]);
        if (key?.toLowerCase() === 'state' || key?.toLowerCase() === 'city') {
        } else if (this.individual[key]) _params[`individual.${key}`] = this.individual[key];
      }
      // _country = this.playerData?.address?.countryData?.id;
    }
    if (this.eInvoiceType === 'company' || this.company?.businessRegistrationNumber?.length > 0) {
      for (let key in this.company) {
        if (key?.toLowerCase() === 'state' || key?.toLowerCase() === 'city') {
        } else if (this.company[key]) _params[`company.${key}`] = this.company[key];
      }
      // _country = this.country;
    }

    // _params = Object.assign(_params, {
    //   individual: _individualForm,
    //   company: _companyForm
    // })
    console.debug('save e-invoice info : ', _params, _companyForm, _individualForm);
    this.flightService.updatePlayerEInvoiceInfo(_player?.playerId || _player?.id, _einvoicingOption, _country, _params).subscribe(
      (player: PlayerData) => {
        if (player) {
          if (!this.fromClub)
            MessageDisplayUtil.showMessageToast('Successfully saved e-invoice info.', this.platform, this.toastCtl, 3000, 'bottom');

          this.modalCtl.dismiss(player);
          return false;
        }
      },
      async error => {
        let _error = error.json();
        let _title = 'Add Membership Failed';
        let _msg = _error.errorMessage;

        let prompt = await this.alertCtl.create({
          header: _title,
          cssClass: 'booking-error',
          message: _msg,
          buttons: [
            {
              text: 'Ok',
              handler: data => {},
            },
          ],
        });
        prompt.present();
        return false;
      }
    );
  }

  getPlayerAddress(attribute?: string) {
    const address = this.playerData?.address;
    switch (attribute) {
      case 'address1':
        return address?.address1;
      case 'address2':
        return address?.address2;
      case 'city':
        return address?.city;
      case 'state':
        return address?.state;
      case 'postCode':
        return address?.postCode;
      case 'country':
        return address?.countryData?.id;
    }
  }

  populateEInvoiceInfo() {
    console.debug('populate info - player data', this.playerData);
    console.debug('populate info - einvoice', this.einvoiceEntity);
    if (this.type === 'updateSetup') {
      if (this.einvoiceEntity?.individual) {
        this.eInvoiceType = 'individual';
        this.individual.name = this.einvoiceEntity?.name;
        this.individual.idType = this.einvoiceEntity?.idType;
        this.individual.idValue = this.einvoiceEntity?.idValue;
        this.individual.taxIdentificationNumber = this.einvoiceEntity?.taxIdentificationNumber;
        this.individual.address.addressLine1 = this.einvoiceEntity?.address?.addressLine1;
        this.individual.address.addressLine2 = this.einvoiceEntity?.address?.addressLine2;
        this.individual.address.city = this.einvoiceEntity?.address?.city;
        this.individual.address.postCode = this.einvoiceEntity?.address?.postCode;
        this.individual.address.state = this.einvoiceEntity?.address?.state;
        this.individual.state = this.einvoiceEntity?.address?.state;
        this.individual.country = this.einvoiceEntity?.country;
        this.individual.city = this.einvoiceEntity?.address?.city;
      } else if (!this.einvoiceEntity?.individual) {
        this.eInvoiceType = 'company';
        this.company.name = this.einvoiceEntity?.name;
        this.company.idType = this.einvoiceEntity?.idType;
        this.company.idValue = this.einvoiceEntity?.idValue;
        this.company.taxIdentificationNumber = this.einvoiceEntity?.taxIdentificationNumber;
        this.company.address.addressLine1 = this.einvoiceEntity?.address?.addressLine1;
        this.company.address.addressLine2 = this.einvoiceEntity?.address?.addressLine2;
        this.company.address.city = this.einvoiceEntity?.address?.city;
        this.company.address.postCode = this.einvoiceEntity?.address?.postCode;
        this.company.address.state = this.einvoiceEntity?.address?.state;
        this.company.state = this.einvoiceEntity?.address?.state;
        this.company.country = this.einvoiceEntity?.country;
        this.company.city = this.einvoiceEntity?.address?.city;
        this.company.businessRegistrationNumber = this.einvoiceEntity?.businessRegistrationNumber;
      }
    } else {
      if (this.playerData) {
        if (this.playerData?.einvoiceEntityIndividual) {
          this.individual.companyName = this.playerData?.einvoiceEntityIndividual?.name;
          this.individual.idType = this.playerData?.einvoiceEntityIndividual?.idType;
          this.individual.idValue = this.playerData?.einvoiceEntityIndividual?.idValue;
          this.individual.incomeTaxNumber = this.playerData?.einvoiceEntityIndividual?.taxIdentificationNumber;
          this.individual.address1 =
            this.playerData?.einvoiceEntityIndividual?.address?.address1 || this.playerData?.addresses[0]?.address?.address1;
          this.individual.phoneNumbers = this.playerData?.einvoiceEntityIndividual?.address?.phoneNumbers?.numbers;
          this.individual.address1 = this.playerData?.einvoiceEntityIndividual?.address?.address1;
          if (!this.individual?.address1 || this.individual?.address1?.length == 0)
            this.individual.address1 = this.getPlayerAddress('address1');
          this.individual.address2 = this.playerData?.einvoiceEntityIndividual?.address?.address2;
          if (!this.individual?.address2 || this.individual?.address2?.length == 0)
            this.individual.address2 = this.getPlayerAddress('address2');
          this.individual.city = this.playerData?.einvoiceEntityIndividual?.address?.city;
          if (!this.individual?.city || this.individual?.city?.length == 0) this.individual.city = this.getPlayerAddress('city');
          this.individual.postalCode = this.playerData?.einvoiceEntityIndividual?.address?.postCode;
          if (!this.individual?.postalCode || this.individual?.postalCode?.length == 0)
            this.individual.postalCode = this.getPlayerAddress('postCode');
          this.individual.state = this.playerData?.einvoiceEntityIndividual?.address?.state;
          if (!this.individual?.state || this.individual?.state?.length == 0) this.individual.state = this.getPlayerAddress('state');
          this.individual.country =
            this.playerData?.einvoiceEntityIndividual.country?.id || this.playerData?.einvoiceEntityIndividual?.address?.countryData?.id;
          if (!this.individual?.country || this.individual?.country?.length == 0)
            this.individual.country = this.getPlayerAddress('country');
          this.individual.phoneNumbers = this.playerData?.einvoiceEntityIndividual.address?.phoneNumbers?.numbers;
        }
        if (this.playerData?.einvoiceEntityCompany) {
          this.company.companyName = this.playerData?.einvoiceEntityCompany.name;
          this.company.businessRegistrationNumber = this.playerData?.einvoiceEntityCompany.businessRegistrationNumber;
          this.company.sst = this.playerData?.einvoiceEntityCompany.sst;
          this.company.tourismNumber = this.playerData?.einvoiceEntityCompany.tourismNumber;
          this.company.incomeTaxNumber = this.playerData?.einvoiceEntityCompany.taxIdentificationNumber;
          this.company.address1 = this.playerData?.einvoiceEntityCompany?.address?.address1;
          this.company.address2 = this.playerData?.einvoiceEntityCompany?.address?.address2;
          this.company.city = this.playerData?.einvoiceEntityCompany?.address?.city;
          this.company.postalCode = this.playerData?.einvoiceEntityCompany?.address?.postCode;
          this.company.state = this.playerData?.einvoiceEntityCompany?.address?.state;
          this.company.country =
            this.playerData?.einvoiceEntityCompany.country?.id || this.playerData?.einvoiceEntityCompany?.address?.countryData?.id;
          this.country =
            this.playerData?.einvoiceEntityCompany.country?.id || this.playerData?.einvoiceEntityCompany?.address?.countryData?.id;
          this.company.phoneNumbers = this.playerData?.einvoiceEntityCompany.address?.phoneNumbers?.numbers;
          // this.company = this.playerData?.einvoiceEntityCompany;
        }
      }
    }
  }

  statesList: Array<State> = [];
  getStatesList() {
    this.flightService.listStates('MYS').subscribe((states: Array<State>) => {
      this.statesList = states;
    });
  }

  async onSelectState() {
    let _documentType = '';
    if (this.eInvoiceType === 'individual') {
      _documentType = this.individual?.idType;
    } else if (this.eInvoiceType === 'company') {
      _documentType = this.company?.idType;
    }

    let _dataList = [];

    if (this.statesList?.length) {
      this.statesList.forEach((state: State) => {
        _dataList.push({
          id: state.stateName,
          name: state.stateName,
        });
      });
    }
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'State',
        selectedValue: _documentType,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      let _idType = '';
      if (data?.data) {
        _idType = data?.data?.id;
        if (this.eInvoiceType === 'individual') {
          this.individual.state = _idType;
          this.individual.address.state = _idType;
          this.individual.city = null;
          this.individual.address.city = null;
        } else if (this.eInvoiceType === 'company') {
          this.company.state = _idType;
          this.company.address.state = _idType;
          this.individual.city = null;
          this.individual.address.city = null;
        }
      }
      // if(data)
    });
  }

  goDismissEInvoiceInfo() {
    if (this.type !== 'updateSetup') return;
    let _individualForm: EInvoicingSetupForm = initEInvoicingSetupForm();
    let _companyForm: EInvoicingSetupForm = initEInvoicingSetupForm();
    let _country = this.country || 'MYS';
    let _einvoicingOption = this.mg2uUtils.capitalizeFirstLetter(this.eInvoiceType);
    let _params = {
      eInvoicingOption: _einvoicingOption,
      // individual: _individualForm,
      // company: _companyForm,
      country: _country,
    };
    if (this.eInvoiceType === 'individual' || this.individual?.idType?.length > 0) {
      for (let key in this.individual) {
        console.debug('form individual : ', key, this.individual[key]);
        if (key?.toLowerCase() === 'state' || key?.toLowerCase() === 'city') {
        } else if (this.individual[key]) _params[`${key}`] = this.individual[key];
        // if (key === 'state') _params[`address.${key}`] = this.individual[key];
      }
      // _country = this.playerData?.address?.countryData?.id;
    }
    if (this.eInvoiceType === 'company' || this.company?.businessRegistrationNumber?.length > 0) {
      for (let key in this.company) {
        console.debug('form company : ', key, this.company[key]);
        if (key?.toLowerCase() === 'state' || key?.toLowerCase() === 'city') {
        } else if (this.company[key]) _params[`${key}`] = this.company[key];
        // if (key === 'state') _params[`address.${key}`] = this.company[key];
      }
      // _country = this.country;
    }

    // _params = Object.assign(_params, {
    //   individual: _individualForm,
    //   company: _companyForm
    // })
    console.debug('update e-invoice info setup : ', _params, _companyForm, _individualForm);
    console.debug('update e-invoice info setup [1]: ', this.individual, this.company);
    this.modalCtl.dismiss(_params);
  }

  getStatesCitiesList() {
    // this.country
    const country = this.country || 'MYS';
    this.citiesList = [];
    this.flightService.getStatesCities(country).subscribe((states: Array<any>) => {
      this.citiesList = states;
      console.debug('states: ', this.citiesList);
      // this.citiesList = JSON.parse(JSON.stringify(states));
    });
  }

  async onSelectCity() {
    let selectedState = '';
    if (this.eInvoiceType === 'individual') {
      selectedState = this.individual?.state;
    } else if (this.eInvoiceType === 'company') {
      selectedState = this.company?.state;
    }
    if (!selectedState || selectedState === '') {
      MessageDisplayUtil.showErrorToast('Please select State first', this.platform, this.toastCtl, 3000, 'bottom');
      return;
    }
    let _dataList = [];

    console.debug('on select city : ', this.citiesList?.length);
    console.log('Type of citiesList:', typeof this.citiesList);
    console.log('Is citiesList an array?', Array.isArray(this.citiesList));
    console.log('citiesList:', this.citiesList);
    if (Array.isArray(this.citiesList) && this.citiesList.length) {
      const filteredState = this.citiesList
        .find((stateCities: StateCities) => stateCities.state.toLowerCase().includes(selectedState.toLowerCase()))
        ?.cities?.sort((a: string, b: string) => a.localeCompare(b))
        ?.forEach((city: string) => _dataList.push({ id: city, name: city }));
      console.debug('_dataList: ', selectedState, filteredState, _dataList);
    } else {
      console.error('citiesList is not an array or is empty:', this.citiesList);
    }
    // if (this.citiesList?.length) {
    //   _dataList = this.citiesList
    //     .filter((stateCities: any) => {
    //       return stateCities.state === selectedState;
    //     })
    //     .map((stateCities: any) => {
    //       return stateCities.cities;
    //     });
    // }
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'City',
        selectedValue: selectedState,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      let _idType = '';
      if (data?.data) {
        _idType = data?.data?.id;
        if (this.eInvoiceType === 'individual') {
          this.individual.city = _idType;
          this.individual.address.city = _idType;
        } else if (this.eInvoiceType === 'company') {
          this.company.city = _idType;
          this.company.address.city = _idType;
        }
      }
      // if(data)
    });
  }

  validatedInfo: {
    idType?: string;
    idValue?: string;
    tin?: string;
    countryId?: string;
    message?: string;
    validated?: boolean;
    success?: boolean;
  } = {
    idType: '',
    idValue: '',
    tin: '',
    countryId: 'MYS',
    message: '',
    validated: false,
    success: false,
  };
  onValidateTIN() {
    let _countryId;
    let _tin;
    let _idType;
    let _idValue;
    if (this.eInvoiceType === 'individual') {
      _countryId = this.individual.country;
      _tin = this.individual?.taxIdentificationNumber || this.individual?.incomeTaxNumber;
      _idType = this.individual?.idType;
      _idValue = this.individual?.idValue;
    } else if (this.eInvoiceType === 'company') {
      _countryId = this.company.country;
      _tin = this.company?.taxIdentificationNumber || this.company.incomeTaxNumber;
      _idType = this.company?.idType || 'BRN';
      _idValue = this.company?.idValue || this.company.businessRegistrationNumber;
    }

    console.debug('on validate tin : ', this.eInvoiceType, _idType, _idValue, _tin, this.company.businessRegistrationNumber, _countryId);
    if (this.eInvoiceType === 'individual') {
      if (!_idType || !_idValue || !_tin) {
        MessageDisplayUtil.showErrorToast('Please fill in ID number and TIN', this.platform, this.toastCtl, 5000, 'bottom');
        return;
      }
    } else {
      if (!_idType || !_tin || !_idValue) {
        MessageDisplayUtil.showErrorToast('Please fill in TIN and BRN', this.platform, this.toastCtl, 5000, 'bottom');
        return;
      }
    }
    // const _countryId = this.inputClubCustomer.country;
    // const _tin = this.inputClubCustomer.incomeTaxNumber;
    // const _idType = this.inputClubCustomer?.individual ? this.inputClubCustomer.idType : 'BRN';
    // const _idValue = this.inputClubCustomer?.individual
    //   ? this.inputClubCustomer.idValue
    //   : this.inputClubCustomer.businessRegistrationNumber;
    const newValidationInfo = {
      idType: _idType,
      idValue: _idValue,
      tin: _tin,
      countryId: _countryId,
    };
    const _params = {
      idType: _idType,
      idValue: _idValue,
    };
    if (this.hasAlreadyValidated()) return;
    this.flightService.checkTINvalid(_countryId, _tin, _params).subscribe(
      (data: any) => {
        if (data) {
          newValidationInfo['validated'] = true;
          newValidationInfo['success'] = true;
          this.validatedInfo = {
            ...newValidationInfo,
            message: `TRN & BRN Validated for TIN : <b>${_tin}</b> & BRN : <b>${_idValue}</b>`,
          };
          // console.debug('validating TIN : ', _countryId, _tin, _params, this.inputClubCustomer, this.validatedInfo);
        }
      },
      error => {
        let _error;
        if (error) {
          _error = error?.error;
          newValidationInfo['validated'] = true;
          newValidationInfo['success'] = false;
          this.validatedInfo = { ...newValidationInfo, message: _error?.errorMessage };
        }
        // console.debug('validating TIN error : ', _countryId, _tin, _params, this.inputClubCustomer, error, this.validatedInfo);
      }
    );
  }

  hasAlreadyValidated() {
    if (!this.validatedInfo) return false;
    let _countryId;
    let _tin;
    let _idType;
    let _idValue;
    if (this.eInvoiceType === 'individual') {
      _countryId = this.individual.country;
      _tin = this.individual?.taxIdentificationNumber || this.individual?.incomeTaxNumber;
      _idType = this.individual?.idType;
      _idValue = this.individual?.idValue;
    } else if (this.eInvoiceType === 'company') {
      _countryId = this.company.country;
      _tin = this.company?.taxIdentificationNumber || this.company.incomeTaxNumber;
      _idType = this.company?.idType;
      _idValue = this.company?.idValue;
    }
    const newValidationInfo = {
      idType: _idType,
      idValue: _idValue,
      tin: _tin,
      countryId: _countryId,
    };
    console.debug('has already validatd ', this.validatedInfo, newValidationInfo);
    if (
      this.validatedInfo?.validated &&
      this.validatedInfo?.idType === _idType &&
      this.validatedInfo?.idValue === _idValue &&
      this.validatedInfo?.tin === _tin &&
      this.validatedInfo?.countryId === _countryId
    )
      return true;
    return false;
  }
}
